/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "Cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('Cart:refresh', {
 *   bubbles: true
 * }));
 */

let theme = window.theme || {};
theme.cart = {
  open: () => {
    var MinicartWrapper = document.querySelector(".Minicart--Wrapper");
    EvolveCore.Helpers.triggerEvent(`Cart:hooked`, EvolveCore.Cart._store.cart);
    let $cart = EvolveCore.Cart._store.cart;
    if (MinicartWrapper) {
    }
  },
  close: () => {
    var MinicartWrapper = document.querySelector(".Minicart--Wrapper");
    if (MinicartWrapper) {
    }
  },
};
window.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('[href*="/cart"]').forEach((element) => {
    element.addEventListener("click", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      theme.cart.open();
    });
  });
  document
    .querySelectorAll(".Minicart--Wrapper .backdrop")
    .forEach((element) => {
      element.addEventListener("click", function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        theme.cart.close();
      });
    });
  document.addEventListener("_EV.Cart:hide", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    theme.cart.close();
  });
  document.addEventListener("_EV.cart:hide", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    theme.cart.close();
  });

  document.addEventListener("_EV.Cart:get:success", async function (evt) {
    let $cart = evt.detail;
    document.querySelectorAll(".cart-link__bubble-num").forEach((element) => {
      element.innerHTML = $cart.item_count;
    });
  });
  document.querySelectorAll('[action="/cart/add"]').forEach((element) => {
    element.addEventListener("submit", async (e) => {
      e.stopPropagation();
      e.preventDefault();

      try {
        const data = new FormData(e.target);

        const formJSON = [Object.fromEntries(data.entries())];

        formJSON.map((item) => {
          item.quantity = +item.quantity;
          item.id = +item.id;
          return item;
        });
        let cart = await EvolveCore.Cart.add(formJSON);
        theme.cart.open();

        if (cart) {
          return $(".header_component--cart:first").click();
        }
      } catch (error) {
        console.log(error.message);
      }
    });
  });
});
document.addEventListener("_EV.core:initialized", async (e) => {
  if (window.location.search === "?redirect_cart") {
    theme.cart.open();
  }
});
document.addEventListener(
  "quizKitResultsPageLoaded",
  function () {
    var quizContent = document.getElementById("quiz-kit-content");
    if (!quizContent) return;

    quizContent.addEventListener("click", async function (e) {
      var button = e.target.closest("[data-variant-id]");
      if (!button) return;

      e.stopPropagation();
      e.preventDefault();

      try {
        await EvolveCore.Cart.add([
          {
            quantity: 1,
            id: button.getAttribute("data-variant-id"),
          },
        ]);
        theme.cart.open();
      } catch (err) {
        /* silencioso em produção */
      }
    });
  },
  { once: true }
);